import { render, staticRenderFns } from "./rolesList.vue?vue&type=template&id=3042c45b"
import script from "./rolesList.vue?vue&type=script&lang=js"
export * from "./rolesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports